<p>add-packers-movers-config works!</p>
